import { Component, Inject, OnInit, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as mapboxgl from 'mapbox-gl';
import { environment } from 'src/environments/environment';
(mapboxgl as any).accessToken = environment.MAPBOX_TOKEN;

@Component({
  selector: 'app-mapa-shape-dialog',
  templateUrl: './mapa-shape-dialog.component.html',
  styleUrls: ['./mapa-shape-dialog.component.css']
})
export class MapaShapeDialogComponent implements OnInit, AfterViewInit {
  map!: mapboxgl.Map;
  loading: boolean = true;
  
  constructor(
    public dialogRef: MatDialogRef<MapaShapeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.criarMapa();
    }, 100);
  }

  async carregarShape(): Promise<void> {
    const sha1 = this.data.shapeSha1;
    const nomeFazenda = this.data.fazenda; 
    
    if (!this.data.link_assinado) return;

    const sourceId = `shape-${sha1}`;
    const fillLayerId = `${sourceId}-fill`;
    const lineLayerId = `${sourceId}-line`;
    const geoJsonUrl = this.data.link_assinado;

    try {
      const response = await fetch(geoJsonUrl);
      const geojson = await response.json();

      const geojsonFiltrado = {
        ...geojson,
        features: geojson.features.filter((feature: any) => {
          const fazendaPropriedade = feature.properties?.FAZENDA;
          return fazendaPropriedade && 
                 fazendaPropriedade.toLowerCase() === nomeFazenda.toLowerCase();
        })
      };

      if (geojsonFiltrado.features.length === 0) {
        console.warn(`Nenhuma feature encontrada para a fazenda "${nomeFazenda}"`, 
          [...new Set(geojson.features.map((f: any) => f.properties?.FAZENDA))]);
      }

      this.map.addSource(sourceId, {
        type: 'geojson',
        data: geojsonFiltrado
      });

      this.map.addLayer({
        id: fillLayerId,
        type: 'fill',
        source: sourceId,
        paint: {
          'fill-color': '#499bbc',
          'fill-opacity': 0.35
        }
      });

      this.map.addLayer({
        id: lineLayerId,
        type: 'line',
        source: sourceId,
        paint: {
          'line-color': '#1c4e80',
          'line-width': 2
        }
      });

      this.ajustarMapaAoGeoJson(geojsonFiltrado);

    } catch (error) {
      console.error('Erro ao carregar shape:', error);
    } finally {
      this.loading = false;
    }
  }

  private ajustarMapaAoGeoJson(geojson: any): void {
    const bounds = new mapboxgl.LngLatBounds();

    geojson.features.forEach((feature: any) => {
      const geom = feature.geometry;
      if (!geom) return;

      switch (geom.type) {
        case 'Polygon':
          geom.coordinates.flat(1).forEach(
            ([lng, lat]: number[]) => bounds.extend([lng, lat])
          );
          break;

        case 'MultiPolygon':
          geom.coordinates.flat(2).forEach(
            ([lng, lat]: number[]) => bounds.extend([lng, lat])
          );
          break;
      }
    });

    if (!bounds.isEmpty()) {
      this.map.fitBounds(bounds, { padding: 60 });
    } else {
      console.warn('Bounds vazios - nenhuma geometria válida encontrada');
    }
  }

  criarMapa(): void {
    this.map = new mapboxgl.Map({
      container: 'map-dialog',
      style: 'mapbox://styles/mapbox/satellite-streets-v11',
      center: [-49.3764, -20.8155],
      zoom: 12
    });

    this.map.on('load', () => {
      this.carregarShape();
    });
  }

  inserirShapeNoMapa(geojson: any): void {
    const sourceId = 'shape-' + this.data.shape_s3;

    this.map.addSource(sourceId, {
      type: 'geojson',
      data: geojson
    });

    this.map.addLayer({
      'id': sourceId + '-fill',
      'type': 'fill',
      'source': sourceId,
      'paint': {
        'fill-color': '#088',
        'fill-opacity': 0.5
      }
    });

    this.map.addLayer({
      'id': sourceId + '-outline',
      'type': 'line',
      'source': sourceId,
      'paint': {
        'line-color': '#088',
        'line-width': 2
      }
    });

    this.navegarParaGeoJson(geojson);
  }

  private navegarParaGeoJson(geojson: any): void {
    const bounds = new mapboxgl.LngLatBounds();

    geojson.features.forEach((feature: any) => {
      const geom = feature.geometry;
      if (!geom || !geom.coordinates) return;

      switch (geom.type) {
        case 'Polygon':
          (geom.coordinates as [number, number][][])
            .forEach(ring => ring.forEach(([lng, lat]) => bounds.extend([lng, lat])));
          break;
        case 'MultiPolygon':
          (geom.coordinates as [number, number][][][])
            .forEach(polygon => polygon.forEach(ring => ring.forEach(([lng, lat]) => bounds.extend([lng, lat]))));
          break;
      }
    });

    if (!bounds.isEmpty()) {
      this.map.fitBounds(bounds, { padding: 50 });
    }
  }

  fechar(): void {
    this.dialogRef.close();
  }
}